<template>
  <div class="d-flex flex-column flex-md-row flex-grow-1 text-center">
    <v-sheet
      class="layout-side mx-auto  d-none d-md-flex flex-md-column justify-space-between px-2 primary"
    >
      <div class="mt-3 mt-md-10 pa-2 white--text">
        <div class="display-2 font-weight-bold">ครูแคร์</div>
        <div class="title font-weight-medium my-2">
          สมุดบันทึกพัฒนาการนักเรียนชั้นปฐมวัยอิเล็กทรอนิกส์
        </div>
        <v-btn to="/register" class="my-4">สมัครสมาชิกที่นี่</v-btn>
      </div>
    </v-sheet>

    <div
      class="d-flex flex-column flex-grow-1 justify-center pa-2 pa-md-4 align-center"
    >
      <div class="layout-content ma-auto w-full ">
        <slot></slot>
      </div>
      <div class="overline mt-4">RATHAKUN - v.0.0.1 (beta)</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("app", ["product"])
  }
};
</script>

<style scoped>
.layout-side {
  width: 420px;
}

.layout-content {
  max-width: 700px;
}
</style>
